import React, { useContext, useEffect } from 'react';
import { AccountContext } from '../Context/AccountContext';
import { overlayHash } from './OnlineAnalysis';

/**
 * This is only a "bootstrapper" for launching the online anaylsis for logged-out users.
 * We basically only show the login dialogue if the hash is present, since the online analysis component
 * itself will take care of showing the modal, after the user is logged-in an the hash is still
 * present in the URL (after the mandatory reload of the page that always happens after the login).
 */
const OnlineAnalysisBootstrapper: React.FunctionComponent = (props) => {
    const { isLoggedIn } = useContext(AccountContext);

    useEffect(() => {
        if (location.hash === '#' + overlayHash && isLoggedIn === false) {
            window.Carbon('dialogues')['carbon-dialog__login-default'].show();
        }
    }, []);

    return null;
};

export default OnlineAnalysisBootstrapper;
